import { cx } from '@emotion/css';
import { sectionTitleCx } from './styles';
import { SectionTitleProps } from './types';

const SectionTitle = (props: SectionTitleProps) => {
  const { title, subtitle, className } = props;

  return (
    <div className={cx(sectionTitleCx, 'section-title', className)}>
      {title && (
        <div className='title'>
          <span>{title}</span>
        </div>
      )}
      {subtitle && (
        <div className='subtitle'>
          <span>{subtitle}</span>
        </div>
      )}
    </div>
  );
};

export default SectionTitle;
